import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchMembershipEventsFailure, fetchMembershipEventsSuccess } from "domains/membershipEvents/actions";
import type { MembershipEvent } from "domains/membershipEvents/types";

export function* fetchMembershipEventsSaga() {
  try {
    const response: { events: MembershipEvent[] } = yield apiFetch("profile/events");
    yield put(fetchMembershipEventsSuccess(response));
  } catch {
    yield put(fetchMembershipEventsFailure());
  }
}
